import { useDataGrid } from "hooks/useDataGrid";
import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "store/globalContext";

export const defaultKanBanData = { records: [], completeRecords: [] };

/** @type {import("types/commonTypes").Referral}*/
export const defaultFormData = {
  id: "",
  createdAt: "",
  status: "Processing",
  note: "",
  practiceName: "",
  practiceEmail: "",
  practicePhone: "",
  practiceAddress: "",
  practiceMarketingRegion: "",
  practiceSpeciality: "",
  originatorName: "",
  originatorJobTitle: "",
  originatorEmail: "",
  originatorPhone: "",
  recipientId: "",
  recipientName: "",
  recipientAddress: "",
  recipientEmail: "",
  recipientPhone: "",
  buttonId: "",
  buttonType: "Virtual",
  type: "Referral",
};

export const useReferrals = ({ onRefresh }) => {
  const navigate = useNavigate();
  const { userData, isGreetingsRead, setIsGreetingsRead } =
    useContext(GlobalContext);
  const disableDownload =
    userData?.role !== "Super Admin" && userData?.role !== "Admin";

  const handleCloseGreetings = () => {
    window.localStorage.setItem(
      `${userData.cognitoId}-is-greetings-read`,
      "true"
    );
    setIsGreetingsRead(true);
  };

  const notificationDataGrid = useDataGrid({
    url: "/referrals",
    reloadIntervalInSeconds: 30,
    defaultSorter: {
      name: "createdAt",
      order: "desc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Notifications`,
    additionalParams: useMemo(
      () => ({
        type: "Notification",
      }),
      []
    ),
    onRefresh,
    highlightRowName: "status",
    highlightRowValue: "New",
  });

  const questionDataGrid = useDataGrid({
    url: "/referrals",
    reloadIntervalInSeconds: 30,
    defaultSorter: {
      name: "createdAt",
      order: "desc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Questions`,
    additionalParams: useMemo(
      () => ({
        type: "Question",
      }),
      []
    ),
    onRefresh,
    highlightRowName: "status",
    highlightRowValue: "New",
  });

  const referralDataGrid = useDataGrid({
    url: "/referrals",
    reloadIntervalInSeconds: 30,
    defaultSorter: {
      name: "createdAt",
      order: "desc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Referrals`,
    additionalParams: useMemo(
      () => ({
        type: "Referral",
      }),
      []
    ),
    onRefresh,
    highlightRowName: "status",
    highlightRowValue: "New",
  });

  const archiveDataGrid = useDataGrid({
    url: "/referrals",
    reloadIntervalInSeconds: 30,
    defaultSorter: {
      name: "createdAt",
      order: "desc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Archive`,
    additionalParams: useMemo(
      () => ({
        type: "Archive",
      }),
      []
    ),
    onRefresh,
  });

  const handleRowClick = ({ id }) => navigate(`/referral/${id}`);
  const isSuperAdmin =
    userData?.role === "Super Admin" ||
    userData?.email === "admin@referral-stream.com";

  return {
    isGreetingsRead,
    handleCloseGreetings,
    handleRowClick,
    notificationDataGrid,
    questionDataGrid,
    referralDataGrid,
    archiveDataGrid,
    disableDownload,
    userData,
    isSuperAdmin,
  };
};
